import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./pages/login/login.component";
import { SecurityQuestionsComponent } from "./pages/security-questions/security-questions.component";
import { RedirectDocusignComponent } from "./redirect-docusign/redirect-docusign.component";
import { RedirectPatientEsignatureComponent } from "./pages/redirect-patient-esignature/redirect-patient-esignature.component";
import { PatientEsignatureAuthorizationComponent } from './pages/patient-esignature-authorization/patient-esignature-authorization.component';
import { SplashPageComponent } from "./splash-page/splash-page.component";

const routes: Routes = [
  { path: 'splash-landing', component: SplashPageComponent },
  { path: 'security-questions', component: SecurityQuestionsComponent },
  { path: "login", component: LoginComponent },
  {
    // path: "credentials/reset-username",
    path: "credentials/:id",
    loadChildren: () =>
      import("./pages/password-reset-form/auth-reset-form.module").then(
        (m) => m.AuthResetFormModule
      ),
  },
  {
    path: "credentials/:id",
    // path: "credentials/reset-password",
    loadChildren: () =>
      import("./pages/password-reset-form/auth-reset-form.module").then(
        (m) => m.AuthResetFormModule
      ),
  },
  {
    path: "patient-esignature-authorization",
    component: PatientEsignatureAuthorizationComponent
  },
  {
    path: "redirect-patient-esignature-authorization",
    component: RedirectPatientEsignatureComponent
  },
  {
    path: "registration",
    loadChildren: () =>
      import("./pages/registration-form/registration-form.module").then(
        (m) => m.RegistrationFormModule
      ),
  },
   {
     path: "registration/create-password/:id",
     loadChildren: () =>
       import("./pages/create-password/create-password.module").then(
        (m) => m.CreatePasswordModule
      ),
   },
   {
     path: "registration/office-contact",
     loadChildren: () =>
      import("./pages/office-contact/office-contact.module").then(
        (m) => m.OfficeContactModule
      ),
   },
  {
    path: "dashboard",
    loadChildren: () =>
      import("./pages/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: "message-portal",
    loadChildren: () =>
      import("./pages/message-portal/message-portal.module").then(
        (m) => m.MessagePortalModule
      ),
  },
  {
    path: "profile",
    loadChildren: () =>
      import("./pages/profile/profile.module").then(
        (m) => m.ProfileModule
      ),
  },
  {
    path: "logout",
    loadChildren: () =>
      import("./pages/logout/logout.module").then((m) => m.LogoutModule),
  },
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  {
    path: 'onredirectionfromdocusign',
    component: RedirectDocusignComponent
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  },
];

//Start: splash screen.
//Replace routes with splashPageRoutes variable for splash screen in forRoot in imports inside NgModule.
// const splashPageRoutes: Routes = [
//   {
//     path: "",
//     component: SplashPageComponent,
//   },
//   {
//     path: "**",
//     redirectTo: "",
//   },
// ]
//End: splash screen.

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
